<template lang="pug">
multiselect(
    track-by="id"
    label="name"
    :options="supplierList"
    :loading="onLoading('fetch-suppliers')"
    @select="onSelect"
    :placeholder="placeholder"
    v-model="value"
    :allow-empty="false"
    select-label=""
    deselectLabel=""
    @search-change="loadSuppliers"
    :internal-search="false"
    :disabled="disabled"
)
    template(slot="option", slot-scope="props")
        .clear
            span.clear {{ props.option.name }}
            small.clear.text-muted(v-if="props.option.outlet == null") All Outlets
            small.clear.text-muted(v-else) {{ props.option.outlet }}
            small.clear.text-muted {{ props.option.region }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import supplier from '@js/store/inventory-fnb/modules/supplier';

export default {
    props: {
        placeholder: {
            type: String,
            default: 'Select Supplier',
        },

        include_all_outlets: {
            type: Boolean,
            default: false,
        },

        disabled: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            value: '',
        };
    },

    computed: {
        ...mapGetters('supplier', ['supplierList']),

        activeOutlet() {
            return this.$store.getters.activeOutlet;
        },
    },

    watch: {
        activeOutlet() {
            this.getSupplierList({
                outlet_id: this.activeOutlet,
                include_all_outlets: this.include_all_outlets,
            });
        },
    },

    beforeCreate() {
        if (!this.$store.hasModule('supplier')) {
            this.$store.registerModule('supplier', supplier);
        }
    },

    mounted() {
        this.loadSuppliers();
    },

    methods: {
        ...mapActions('supplier', ['getSupplierList']),

        onSelect(supplier) {
            this.$emit('input', supplier);
        },

        loadSuppliers: _.debounce(function(query = '') {
            const params = {
                query,
                outlet_id: this.activeOutlet,
                include_all_outlets: this.include_all_outlets,
            };

            this.getSupplierList(params);
        }, 500),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/selector/fnb-supplier-selector.vue